import QRCode from "qrcode.react";
import { useEffect } from "react";
import Helmet from "react-helmet";
import { Link, useParams } from "react-router-dom";

import { useIsLoading } from "shared/hooks/requestStatusHooks";

import { getCase } from "app/actions/caseActions";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useSelectedLabStation } from "hooks/useSelectedLabStation";
import CaseHierarchy from "ui/accessioning/CaseHierarchy";
import AccessionNumber from "ui/components/AccessionNumber";
import AppSpinner from "ui/components/AppSpinner";

const CaseBarcodes = () => {
  const dispatch = useAppDispatch();
  const selectedLabStationId = useSelectedLabStation().id;
  const case_id = Number(useParams().case_id);
  const pathCase = useAppSelector((state) => state.case);
  const loadingCase = useIsLoading(getCase, {
    id: case_id,
    parentLookupLabStationId: selectedLabStationId,
  });

  useEffect(() => {
    if (case_id && (!pathCase?.id || case_id !== pathCase?.id)) {
      dispatch(
        getCase({ id: case_id, parentLookupLabStationId: selectedLabStationId })
      );
    }
  }, [case_id, pathCase?.id]);

  if (pathCase?.id !== case_id || loadingCase)
    return <AppSpinner>Loading Case...</AppSpinner>;

  return (
    <div className="CaseWrapper CaseBarcodes">
      <Helmet>
        <title>{`Case ${pathCase?.id} Barcodes`}</title>
      </Helmet>

      <header className="Case__header">
        <figure className="Logo">
          <Link to="/cases">
            <img src="/logo.svg" alt="Back to case list" />
          </Link>
        </figure>
        {pathCase?.accession && (
          <AccessionNumber accession={pathCase?.accession} />
        )}
        {pathCase?.patient?.last_name}, {pathCase?.patient?.first_name}
        <span>
          ({pathCase?.patient?.sex} &ndash; {pathCase?.patient?.date_of_birth})
        </span>
        <Link to=".." className="Case__header__edit">
          Back
        </Link>
      </header>
      <div>
        <h1>Case Documents</h1>
        {pathCase.documents.map((document) => (
          <div className="d-flex">
            {document.name}
            <QRCode
              className="barcode"
              value={`document-${document.id}`}
              renderAs="svg"
            />
          </div>
        ))}
      </div>
      <div>
        <h1>Case Hierarchy</h1>
        <CaseHierarchy pathCase={pathCase} showBarcodes />
      </div>
    </div>
  );
};

export default CaseBarcodes;
